module.exports = __webpack_public_path__ + "img/00010.42e8b833.webp";